import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllCutReturnContlist, selectAllCutReturnInlist } from '../../Selectors/Master/ItemSelectors';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchAllCutReturnContractor, fetchAllCutReturnInhosuelist } from '../../../Store/PHPSlice/Cutting/cuttingApi';
import PreviewIcon from '@mui/icons-material/Preview';

const MainContReturnInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        empType: '',
        cutId: '',
        cutMemo: '',
        reMemo: '',
        itemId: '',
        itemNm: '',
        reQty: '',
        totQty: '',
        gMtr: '',
        actAvg: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        soId: '',
        sono: '',
        partyId: '',
        partyNm: '',
        schlNm: '',
        schlId: '',
        mavg: '0',
        m1avg: '0',
        m2avg: '0',
        m3avg: '0',
        userId: '1'
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    // const returnInfolist = useSelector(selectAllCutReturnContlist);
    const returnInfolist = useSelector(selectAllCutReturnInlist);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        // dispatch(fetchAllCutReturnContractor(Id));
        dispatch(fetchAllCutReturnInhosuelist(Id));
    }, [Id]);

    useEffect(() => {
        if (returnInfolist.data) {
            const item = returnInfolist.data;
            setFormData(prev => ({
                ...prev,
                dt: item.dt || '',
                empId: item.empId || '',
                empNm: item.empNm || '',
                empType: item.empType || '',
                itemId: item.itemId || '',
                itemNm: item.itemNm || '',
                reQty: item.totReturnqty || '',
                totQty: item.totIssqty || '',
                soId: item.soId || '',
                sono: item.sono || '',
                gMtr: item.mgmtr || '',
                cutMemo: item.ctMemo || '',
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
                instruction: item.instruction,
            }));
        }


    }, [returnInfolist]);

    var compData = Array.isArray(returnInfolist?.data2) ? returnInfolist?.data2?.map((item, index) => (

        {
            serialNumber: index + 1,
            dt: item.dt,
            ctId: formData.cutId,
            retMemo: item.ctreMemo,
            reQty: item.reqty,
        }
    )) : [];
    const handleViewClick = (id) => {
        window.open(`/ContractorReturnInfo/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleFinalPrint = () => {
        // window.open(`/CuttingFinalPrint/${Id}`, '_blank', 'width=1200,height=700,scrollbars=yes,resizable=yes');
    }
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Return Info</h3>
                        <div className="dashed-line"></div>


                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.cutMemo}</td>

                                </tr>

                                {formData.soId !== '0' &&
                                    <>
                                        <tr>
                                            <td style={{ width: '200px' }}>Sale Order No.</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>
                                            <td style={{ width: '200px' }}>Party</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                        </tr>

                                        <tr>
                                            <td style={{ width: '200px' }}>School Name</td>
                                            <td>:</td>
                                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                        </tr>
                                    </>

                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Total Issue Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>
                                    <td style={{ width: '200px' }}>Total Return Qty.</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.reQty}</td>

                                </tr>
                                <tr>

                                    <td style={{ width: '200px' }}>Cutting Instruction</td>
                                    <td>:</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>
                                </tr>

                            </tbody>
                        </table>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>

                                <tr>
                                    <td style={{ width: '200px' }}>Main Cloth : </td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>Matching-1 : </td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>


                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>Matching-2 : </td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>

                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '200px' }}>Matching-3 : </td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>

                                    </tr>
                                }


                            </tbody>

                        </table>
                        <table style={{ margin: '1% 5%' }}>
                            <tbody>
                                <tr>
                                    <td><h4 style={{ color: '#ff0b0b' }}>Inward Details : </h4></td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }}><h4 style={{ color: '#4d79ff', cursor: 'pointer' }} onClick={handleFinalPrint}>Final Print</h4></td>
                                </tr>
                            </tbody>
                        </table>
                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Date</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Return Memo No.</TableCell>
                                        {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Cutting Memo No.</TableCell> */}
                                        {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell> */}
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>View</TableCell>

                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {compData.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.serialNumber}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.dt}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.retMemo}</TableCell>
                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.cutMemo}</TableCell> */}
                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.totQty}</TableCell> */}
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.reQty}</TableCell>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                                                <PreviewIcon onClick={() => handleViewClick(item.retMemo)} />
                                            </TableCell>
                                        </TableRow>

                                    ))}

                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default MainContReturnInfo;
